import { render } from "./Router.vue?vue&type=template&id=19b0b7eb"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "19b0b7eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19b0b7eb', script)) {
    api.reload('19b0b7eb', script)
  }
  
  module.hot.accept("./Router.vue?vue&type=template&id=19b0b7eb", () => {
    api.rerender('19b0b7eb', render)
  })

}

script.__file = "src/icons/components/filled/Router.vue"

export default script